import { IAPI_RET004_Response } from "../../../type/apiType";

/**
 * 処理履歴を作成する
 * @param res
 * @returns statusBodyList
 */
function funStatusBodyList(memoList: IAPI_RET004_Response["memoList"]) {
  const statusBodyList = memoList?.map((item) => [
    {
      children: item.managerName,
    },
    {
      children: item.process,
    },
    {
      children: item.createDate,
      align: "center",
    },
    {
      children: item.processComment,
    },
  ]);

  return statusBodyList ?? [];
}

/**
 * 中小企業退職金共済契約締結届のダウンロードリンク用のラインのないテーブルを作成する
 * @param res
 * @returns downloadBodyList
 */

function fundownloadBodyList(res: IAPI_RET004_Response) {
  const downloadBodyList = [
    [
      {
        children: res.approvalDate,
      },
      { children: res.symbolNo },
    ],
  ];

  return downloadBodyList;
}

export { funStatusBodyList, fundownloadBodyList };
